import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import WalletUnlock from "./wallet-unlock"
import { WalletSetPassword } from "./wallet-set-password"

interface WalletSetPasswordModalProps {
  children: React.ReactNode;
}

export function WalletSetPasswordModal({
  children,
}: WalletSetPasswordModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Change Wallet Secret PIN</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <WalletUnlock>
          <WalletSetPassword />
        </WalletUnlock>
      </DialogContent>
    </Dialog>
  )
}
